<svg istag="svgcomp"></svg>
